import React from 'react';
import { ErrorHero } from './ErrorHero';
import { useRouter } from 'next/router';
import Head from 'next/head';
import { useI18NextContext } from '@components/hooks';
import { withIsServer } from '@components/hoc';
import { sentryException } from '@util/sentry';
import { ErrorPageProps } from '@model/common/error-codes';

export const Error401 = withIsServer(({ code, isServer }: ErrorPageProps) => {
  const router = useRouter();
  const handleOnClick = () => router.back();
  const t = useI18NextContext();
  const subtitle = t('error__401__code');
  if (!isServer) {
    sentryException(`${subtitle}${code ? `: ${code}` : ''}`);
  }

  return (
    <>
      <Head>
        <title>{`${subtitle} | ${t('common__brand_display')}`}</title>
      </Head>
      <ErrorHero
        title={t('error__401__title')}
        subtitle={subtitle}
        code={code}
        src={'/assets/images/error/error-401.jpg'}
        buttonLabel={t('common__label--returning')}
        onClick={handleOnClick}
        paragraph={t('error__401__paragraph')}
      />
    </>
  );
});
